import React, { useState } from "react";
import CheckboxCustomInput from "shared-components/Components/CheckboxCustomInput";
import DinamicInputText, {
	TextAreaDinamicInput,
} from "src/Components/InputComponent";
import "../ContactUs/styles.less";

type Props = {
	main_domain: string;
	country_code: string;
};

const AdvertiseWithUs = ({ main_domain, country_code }: Props) => {
	const [phone, setPhone] = useState<string>("");

	const countryCodes: Record<string, string> = {
		CO: "+57",
		PE: "+51",
		UY: "+598",
		PY: "+595",
		BO: "+591",
	};

	const defaultCountryCode = countryCodes[country_code] || "+57";

	const handlePhone = (e: React.ChangeEvent<HTMLInputElement>) => {
		const { value } = e.target;
		const isNumeric = /^[0-9\b]+$/;
		if (value === "" || isNumeric.test(value)) {
			setPhone(value);
		}
	};

	return (
		<div className="ContactUs">
			<form onSubmit={() => console.log("submit")}>
				<div className="contactUs__header">
					<h2>Anuncia con Nosotros</h2>
					<p>Haz tus inmuebles más visibles, déjanos tus datos y te contactaremos</p>
				</div>
				<div className="contactUs__form">
					<DinamicInputText
						id="nombres-completos"
						name="nombres-completos"
						placeholder="Nombres y Apellidos"
						required={true}
					/>
					<DinamicInputText id="email" name="email" placeholder="Correo electrónico" />
					<div className="contactUs__form__phone">
						<DinamicInputText
							id="codigo"
							name="codigo"
							placeholder="Código"
							defaultValue={defaultCountryCode}
						/>
						<DinamicInputText
							value={phone}
							onChange={handlePhone}
							id="telefono"
							name="telefono"
							placeholder="Teléfono (opcional)"
						/>
					</div>
					<TextAreaDinamicInput
						id="mensaje"
						name="mensaje"
						placeholder="Déjanos tu mensaje"
						required={true}
					/>
					<CheckboxCustomInput>
						<p>
							Acepto <a href="/informacion#aviso-legal">aviso legal</a> y la{" "}
							<a href="/informacion#politicas-de-privacidad">protección de datos</a> de{" "}
							{main_domain}
						</p>
					</CheckboxCustomInput>
					<button className="contactUs__form__submit" type="submit">
						Enviar Formulario
					</button>
				</div>
			</form>
		</div>
	);
};

export default AdvertiseWithUs;
